import React from "react";
import Icon from "./Icon";


export default function Message(props) {
  return (
    <div className={`ds-message ${props.type}`}>
      <Icon icon={props.type}  />
      <p>{props.description}</p>
    </div>
  )
}


/*

Usage:

<Message type="" description="" />

- type: info / success / warning / alert
- description: String

*/